import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { NotificacaoPedidoDTO } from '../../../../models/pedidos/notificacao-pedido.model';
import { ESTADO_PEDIDO_CONFIG } from '../../../../enums/EstadoDePedido.enum';

const DURACAO_AUTO_DISMISS_MS = 12000;
const INTERVALO_PROGRESSO_MS = 100;

@Component({
  selector: 'app-notificacao-pedido-dialog',
  templateUrl: './notificacao-pedido-dialog.component.html',
  styleUrls: ['./notificacao-pedido-dialog.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(24px) scale(0.96)' }),
        animate('220ms ease-out', style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
      ]),
      transition(':leave', [
        animate('180ms ease-in', style({ opacity: 0, transform: 'translateY(16px) scale(0.96)' })),
      ]),
    ]),
  ],
})
export class NotificacaoPedidoDialogComponent implements OnChanges, OnDestroy {

  @Input() visivel = false;
  @Input() notificacao: NotificacaoPedidoDTO | null = null;
  @Input() texts = {
    titulo: '',
    pedido_numero: '',
    cliente: '',
    estado: '',
    ver_pedido: '',
    fechar: '',
  };

  @Output() visivelChange = new EventEmitter<boolean>();
  @Output() verPedido = new EventEmitter<number>();

  progressoAutoDismiss = 100;

  private timerAutoDismiss?: ReturnType<typeof setTimeout>;
  private timerProgresso?: ReturnType<typeof setInterval>;
  private tempoDecorrido = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visivel']) {
      if (this.visivel) {
        this.iniciarAutoDismiss();
      } else {
        this.cancelarAutoDismiss();
      }
    }
  }

  ngOnDestroy(): void {
    this.cancelarAutoDismiss();
  }

  onFechar(): void {
    this.cancelarAutoDismiss();
    this.visivelChange.emit(false);
  }

  onVerPedido(): void {
    if (this.notificacao?.pedidoId) {
      this.verPedido.emit(this.notificacao.pedidoId);
    }
  }

  getCorEstado(): string {
    if (!this.notificacao?.estadoAtual) return '#999';
    const config = ESTADO_PEDIDO_CONFIG[this.notificacao.estadoAtual as keyof typeof ESTADO_PEDIDO_CONFIG];
    return config?.cor || '#999';
  }

  getIconeEstado(): string {
    if (!this.notificacao?.estadoAtual) return 'pi pi-circle';
    const config = ESTADO_PEDIDO_CONFIG[this.notificacao.estadoAtual as keyof typeof ESTADO_PEDIDO_CONFIG];
    return config?.icone || 'pi pi-circle';
  }

  formatarHora(): string {
    if (!this.notificacao?.timestamp) return '';
    try {
      const data = new Date(this.notificacao.timestamp);
      return data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return '';
    }
  }

  private iniciarAutoDismiss(): void {
    this.cancelarAutoDismiss();
    this.tempoDecorrido = 0;
    this.progressoAutoDismiss = 100;

    // Atualizar barra de progresso a cada intervalo
    this.timerProgresso = setInterval(() => {
      this.tempoDecorrido += INTERVALO_PROGRESSO_MS;
      this.progressoAutoDismiss = Math.max(
        0,
        100 - (this.tempoDecorrido / DURACAO_AUTO_DISMISS_MS) * 100
      );
    }, INTERVALO_PROGRESSO_MS);

    // Fechar automaticamente apos a duracao
    this.timerAutoDismiss = setTimeout(() => {
      this.onFechar();
    }, DURACAO_AUTO_DISMISS_MS);
  }

  private cancelarAutoDismiss(): void {
    if (this.timerAutoDismiss) {
      clearTimeout(this.timerAutoDismiss);
      this.timerAutoDismiss = undefined;
    }
    if (this.timerProgresso) {
      clearInterval(this.timerProgresso);
      this.timerProgresso = undefined;
    }
    this.progressoAutoDismiss = 0;
  }
}
